import { ButtonSize } from 'components/Button';
import { FormControlSize } from 'shared/types/formControl';

export const closeButtonSizeMap: Record<FormControlSize, ButtonSize> = {
  sm: 'xs',
  md: 'sm',
  lg: 'md',
};
